<script setup lang="ts">
import { computed } from "vue";
import TextCardOptions from "./TextCardOptions.vue";
import ImageCardOptions from "./ImageCardOptions.vue";
import { contentSubtype } from "./constants";

const props = defineProps({
  card: { type: Object, required: true },
});

// One options panel per content sub_type (mirrors CONTENT_CARD_TYPES in constants).
const SUBTYPE_COMPONENTS = {
  text: TextCardOptions,
  image: ImageCardOptions,
};

const optionsComponent = computed(() => SUBTYPE_COMPONENTS[contentSubtype(props.card)] || null);
</script>

<template>
  <component :is="optionsComponent" v-if="optionsComponent" :card="card" />
</template>
